import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fromJS, Map } from 'immutable';
import { Attachment } from '../../../attachments/attachment.model';
import { IFormMasterBuilder } from '../../../form-master/form-master.interface';

@Injectable()
export class AttachmentInfoFormBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    TITLE: 'title',
    DESCRIPTION: 'description',
  };

  constructor(private _formBuilder: FormBuilder) {}

  buildForm(attachment: Attachment): FormGroup {
    return this._formBuilder.group({
      [this.FORM_KEYS.TITLE]: [
        attachment.title,
        [Validators.required, Validators.maxLength(250)],
      ],
      [this.FORM_KEYS.DESCRIPTION]: [attachment.description],
    });
  }

  buildAttachmentProps(attachmentInfo: Map<string, any>): Map<string, any> {
    let attachmentProps = {
      [Attachment.KEYS.TITLE]: attachmentInfo.get(this.FORM_KEYS.TITLE),
      [Attachment.KEYS.DESCRIPTION]: attachmentInfo.get(
        this.FORM_KEYS.DESCRIPTION
      ),
    };

    return fromJS(attachmentProps);
  }
}
